import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchData } from 'services/api/useFetchData';
import { AdditionalModule } from './BillingTypes';
import ModuleOrderCard from './ModuleOrderCard';
import '../../../style/scss/billing.scss';

const HighlightedModuleCards: React.FC = () => {
    const { t } = useTranslation();

    // Fetch the promotable highlighted modules for this environment
    const { response: fetchedModules, refetch: refetchModules } = useFetchData({
        apiUrl: 'get_highlighted_module_list'
    });

    // Get the highlighted modules from the response
    const highlightedModules: AdditionalModule[] = fetchedModules?.results || [];

    // Hide the section when there are no highlighted modules to show
    if (highlightedModules.length === 0) {
        return null;
    }

    return (
        <div className='highlighted-modules'>

            {/* Show the section header above the highlighted module cards */}
            <div className='module-section-header'>
                <h3>{t('billing.general.highlighted_modules_header')}</h3>
            </div>

            {/* Show a wide order card for every highlighted module */}
            {highlightedModules.map(module => (
                <ModuleOrderCard
                    key={module.feature}
                    feature={module.feature}
                    title={t(module.feature_translation)}
                    description={module.description ?? undefined}
                    priceType={module.price_type}
                    flatPrice={module.flat_price}
                    pricePerSeat={module.price_per_seat}
                    onOrdered={refetchModules}
                />
            ))}
        </div>
    );
};

export default HighlightedModuleCards;
